/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import {
  CommandResult_Travel,
  CommandResult_VehiclePosition,
  ListCommandResult_Travel
} from "@graphql/helpers/types.graphql";
import {
  CommandResult,
  ListCommandResult
} from "@graphql/groups/fragment.graphql";
import utils, {
  TTravelType,
  TNonEmptyArray,
  TJoin,
  TConcretingType,
  TConcreteMixerType,
  TVehiclePositionType,
  TDriverType
} from "@graphql/helpers/utils.graphql";

type TTravelByIdFunctions = {
  getByID: CommandResult_Travel;
};
export type TTravelByIdQueries = {
  travel: TTravelByIdFunctions;
};

type TGlobal =
  | TTravelType
  | TJoin<"concreting", TConcretingType>
  | TJoin<"concreteMixer", TConcreteMixerType>
  | TJoin<"driver", TDriverType>;

export const travelById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query travelById($id: Guid!) {
    travel {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Travel")}
`;

type TTravelAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_Travel;
};
export type TTravelAllWithPaginationQueries = {
  travel: TTravelAllWithPaginationFunctions;
};
export const travelAllWithPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query travelAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    travel {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Travel")}
`;

type TVehiclePositionByExternalIdFunctions = {
  getPositionByExternalId: CommandResult_VehiclePosition;
};
export type TVehiclePositionByExternalIdQueries = {
  travel: TVehiclePositionByExternalIdFunctions;
};

export const positionByExternalId = (
  fields: TNonEmptyArray<TVehiclePositionType>
) => gql`
  query positionByExternalId($externalId: String!) {
    travel {
      getPositionByExternalId(externalId: $externalId) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_VehiclePosition")}
`;
